<template>
<div class="container-fluid headMenu" v-if="$parent.showHead">
  <nav class="navbar  navbar-expand-sm container" >

      <a class="navbar-brand w-75px" href="/">
                <img width="85" height="54" alt="FlixLatino" class="logo-head w-75px " :src="$parent.img('https://flxassets.flixlatinogo.com/2020/img/logo_flix_2020.png')">
        </a>


    <a class="col btn d-block d-sm-none quienessomos" :href="'/sections/about'+$parent.cuLang">{{$parent.lang.aboutUs}}</a>
        <a class=" btn d-block d-sm-none btn-outline-danger mrx-1" role="button" v-on:click="$parent.login()" >{{$parent.lang.login}}</a>
<!--        <a class="col btn btn-danger d-block d-sm-none" v-on:click="$parent.suscribe()">{{$parent.lang.freeTrial}}</a>-->

          
    <button class="navbar-toggler" alt="menu" type="button" v-on:click="toggleMenu()" aria-label="Menu">
      <span class="navbar-toggler-icon">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </span>
    </button>
   
    <div class="collapse navbar-collapse" v-bind:class="{ show: menuShow }" >
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link btn" rel="noopener" href="https://flixlatinogo.zendesk.com/hc/es">{{$parent.lang.helpDesk}}</a>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto" id="navbar-list-2">
        <li class="nav-item">
          <a class="nav-link btn" :href="'/sections/about'+$parent.cuLang">{{$parent.lang.aboutUs}}</a>
        </li>
         <li class="nav-item">
          <a class="nav-link btn" :href="'/programming/'+$parent.cuLangAsk">{{$parent.lang.demo}}</a>
        </li>
         <li class="nav-item">
           <a v-on:click="$parent.login()" class="nav-link btn btn-outline-danger mrx-1" role="button">{{$parent.lang.login}}</a>
        </li>
<!--         <li class="nav-item">-->
<!--          <a class="nav-link btn btn-danger" v-on:click="$parent.suscribe()">{{$parent.lang.freeTrial}}</a>-->
<!--        </li>-->
         <li class="nav-item">
          <a class="nav-link btn" v-on:click="$parent.langToggle()" >{{$parent.lang.langToggle}}</a>
        </li>
      </ul>
    </div>
  </nav>
</div>

</template>


<script>




export default {
  name: 'flixMenu',
  components: {
  },
  data(){ return {
     menuShow: false,
     
    }
  },
  created: function () {


    // this.lang = lang.es
    // console.log(this.lang);
    
  },
  updated: function(){
    // this.profiling();

  },
  computed:{

  },
  
  methods:{

    toggleMenu:function(){
      console.log('menu toggle')
       this.menuShow = !this.menuShow;
    }
    

    

  }
  
}
</script>

<style>
.btn-outline-danger {
  border: 1px solid white;
}
.mrx-1{
  margin: 0 1em;
}
.w-75px{
  width: 75px;
}
.navbar-brand > .logo-head{
  max-height: 75px;
  padding: 0 5px;
  width: 95px;
  height: auto;
  margin-bottom: 0;
  top: 0px;
}
/* Portrait */
@media only screen
and (min-device-width: 320px)
and (max-device-width: 568px)
and (-webkit-min-device-pixel-ratio: 2)
and (orientation: portrait) {
  .quienessomos{padding: 0}
}


</style>